import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const PinDocumentIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M13.758 0H3C1.35 0 0 1.35 0 3V27C0 28.65 1.35 30 3 30H21C22.65 30 24 28.65 24 27V10.242C24 9.447 23.6835 8.6835 23.121 8.121L15.879 0.879C15.3165 0.3165 14.553 0 13.758 0ZM21.75 10.5H13.5V2.25L21.75 10.5Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

PinDocumentIcon.propTypes = {
  sx: PropTypes.object,
};

export default PinDocumentIcon;
